import React from 'react';
import { getHexByColorName } from '../../../utils/ColorManager';
import VerticalFold from '../../ui/VerticalFold/VerticalFold';
import * as styles from './Filter.module.scss';
import classnames from 'classnames';
import { filterToLabel } from '../../../utils/FilterHelper';

export interface IFilter {
    type: string; 
    options: Array<{name: string; value: string; }>;
}

type Props = {
    config: IFilter;
    onChange?: (type: string, data: Array<string>) => any;
};
 
export default (props: Props) => {
    const { config, onChange } = props;
    const [selected, setSelected]: [Array<string>, Function] = React.useState([]);

    const filterName = config.type.charAt(0).toUpperCase() + config.type.slice(1);

    const [modalOpen, setModalOpen] = React.useState(false);

    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    // No filter if just one option is available
    if (config.options.length <= 1) {
        return null;
    }

    const onCheckChange = (e) => {
        const value = e.target.name;

        let newSelected = [...[], ...selected];

        // add if not in array
        if (e.target.checked && newSelected.indexOf(value) <= -1) {
            newSelected.push(value);
        }

        // remove if in array
        if (!e.target.checked && newSelected.indexOf(value) > -1) {
            newSelected.splice(newSelected.indexOf(value), 1);
        }

        setSelected(newSelected);
    }

    React.useEffect(() => {
        onChange(config.type, selected);
    }, [selected]);


    let filterUi: any;


    switch (config.type.toLowerCase()) {

        case "farben": 
            filterUi = <VerticalFold elementsToShow={6} foldableOnBreakpoints={["desktop", "tablet"]}>
                {config.options.map((o, oKey) => {
                    const checked: boolean = (selected.indexOf(o.value) === -1) ? false : true;
                    const color = getHexByColorName(o.value);

                    return  <label key={oKey} className={classnames(["checkbox", styles.label])}>
                            <input style={{display: "none"}} type="checkbox" onChange={onCheckChange} name={o.value} checked={checked} />
                                <svg className={styles.checkboxSvg} width="20px" height="20px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "square", strokeMiterlimit:10}}>
                                    <rect x="0.375" y="0.375" width="18" height="18" style={{fill: "none", stroke: "#005792", strokeWidth: "0.75px"}}/>
                                    {(selected.indexOf(o.value) !== -1) && <path id="check" d="M3.187,9.906l5.576,5.577l7.296,-12.216" style={{fill: "none", stroke: "#005792", strokeWidth: "0.75px", strokeLinejoin: "round", strokeMiterlimit:1.5}}/> }
                                </svg>
                                <span className={styles.colorTag} style={{background: color.color}}></span>
                                <span>
                                    {o.name}
                                </span>
                                
                        </label>
                })}
            </VerticalFold>
            break;

        default:
            filterUi =  <VerticalFold elementsToShow={5} foldableOnBreakpoints={["desktop", "tablet"]}>
                {config.options.map((o, oKey) => {
                    return <div key={oKey}>
                       
                        <label className={classnames(["checkbox", styles.label])}>
                            <svg className={styles.checkboxSvg} width="20px" height="20px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "square", strokeMiterlimit:10}}>
                                <rect x="0.375" y="0.375" width="18" height="18" style={{fill: "none", stroke: "#005792", strokeWidth: "0.75px"}}/>
                                {(selected.indexOf(o.value) !== -1) && <path id="check" d="M3.187,9.906l5.576,5.577l7.296,-12.216" style={{fill: "none", stroke: "#005792", strokeWidth: "0.75px", strokeLinejoin: "round", strokeMiterlimit:1.5}}/> }
                            </svg>
                            <span>
                                {o.name}
                            </span>
                            <input className={styles.checkbox} type="checkbox" onChange={onCheckChange} name={o.value} checked={(selected.indexOf(o.value) === -1) ? false : true} />
                        </label>
                    </div>
                })}
            </VerticalFold>
    }


    return <div className={styles.filterWrapper}>
        

                <div className={styles.filterTitle}>
                    <h4 className={classnames(["title",  "is-4"])} onClick={openModal}>
                        {(selected.length > 0) ? <span>({selected.length})</span> : null }
                        {filterToLabel(filterName)}
                    </h4>
                   
                </div>
                

                <div className={classnames(["modal", styles.mobileModal, (modalOpen) ? "is-active" : ""])}>
                    <div className={classnames(["modal-background", styles.mobileModalBackground])} onClick={closeModal}></div>
                    <div className={classnames(["modal-card", styles.mobileModalCard])}>
                        <header className={classnames(["modal-card-head", styles.mobileModalHeader])}>
                            <p className="modal-card-title" style={{marginBottom: 0}}>{filterName}</p>
                            <button className="delete" aria-label="close"  onClick={closeModal}></button>
                        </header>
                        <section className={classnames(["modal-card-body", styles.mobileModalBody])} >
                            {filterUi}
                        </section>
                        <footer className={classnames(["modal-card-foot", styles.mobileModalFooter])}>
                        <button className="button"  onClick={closeModal}>Ergebnisse anzeigen</button>
                        </footer>
                    </div>
                </div>
        
    </div>
}